// §4.4 partial — admin/logs route.
// /admin/logs renders the AdminLogsPage (auditoria + system events).
// Backend wire: GET /api/v2/admin/logs (paginated).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminLogsPage = lazyWithRetry(() => import("./pages/AdminLogsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/logs", Component: AdminLogsPage },
      // Auditoria alias — legacy parity, same paginated audit/system view.
      { path: "/admin/auditoria", Component: AdminLogsPage },
    ],
  },
];

export default routes;
